import { render, staticRenderFns } from "./ExploreWidget.vue?vue&type=template&id=0f45eec0&scoped=true"
import script from "./ExploreWidget.vue?vue&type=script&lang=js"
export * from "./ExploreWidget.vue?vue&type=script&lang=js"
import style0 from "./ExploreWidget.vue?vue&type=style&index=0&id=0f45eec0&prod&scoped=true&lang=scss"
import style1 from "./ExploreWidget.vue?vue&type=style&index=1&id=0f45eec0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f45eec0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VList,VListItem,VMenu})
